import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { group } from 'console';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-performance-history',
  templateUrl: './performance-history.component.html',
  styleUrls: ['./performance-history.component.css']
})
export class PerformanceHistoryComponent implements OnInit {


  singleObjectInfoData: any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: number = 0;
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  objectInfoList: any = []
  objectInfoListFilter: any = []
  isLoading: any = false
  objectInfoId: any

  basicData: any;
  data: any;
  data1: any;
  data2: any;
  data3: any;
  data4: any;
  options: any;
  lineOptions: any;

  isDisplayGrid: any = false

  dataSet1: any;
  dataSet2: any;
  dataSet3: any;
  dataSet4: any;

  objectTemplateId = ""
  originalCost: any = ""
  currentCost: any = ""
  branch: any = ""
  department: any = ""
  make: any = ""
  model: any = ""
  location: any = ""
  objectCondition: any = ""
  givenName: any = ""
  serialNumber: any = ""
  locationList: any = []
  branchList: any = []
  maintenanceList: any = []
isLoading1: any = false
  maintenanceType = [
    {
      key: "Preventive Maintenance (PM) Schedule",
      value: "PreventiveMaintenanceSchedule"
    },
    {
      key: "Corrective Maintenance Schedule",
      value: "CorrectiveMaintenanceSchedule"
    },
    {
      key: "Predictive Maintenance Schedule",
      value: "PredictiveMaintenanceSchedule"
    },
    {
      key: "Condition-Based Maintenance (CBM)",
      value: "ConditionBasedMaintenance"
    }
  ]

  frequencyType = [
    {
      key: "Daily: Operational checks (temperature, pressure, noise, etc.)",
      value: "Daily"
    },
    {
      key: "Weekly: Lubrication, filter checks, fluid levels",
      value: "Weekly"
    },
    {
      key: "Monthly: In-depth inspections, cleaning, software updates",
      value: "Monthly"
    },
    {
      key: "Quarterly: Component replacements (belts, seals), diagnostics",
      value: "Quarterly"
    },
    {
      key: "Annually: Major overhauls, part replacements, certifications",
      value: "Annually"
    }
  ]

  showFilter: any = false
  objectTypeData: any = [];
  objectGroupData: any = [];
  usersList: any = [];
  maintenanceScheduleList: any = [];
  file: any;
  imagesList: any = [];
  largeImage: any = "";
  iconFile: any;
  icon: any = '';


  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService
  ) { }

    // themeEffect = effect(() => {
    //     if (this.configService.transitionComplete()) {
    //         if (this.designerService.preset()) {
    //             this.initChart();
    //         }
    //     }
    // });


  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getFourRandomArrays()
    this.getAllByAssetMonitoringAndCid(true)
    this.generateLastSevenDays()

    this.getAllLocation()
    this.getAllBranch()
    this.getAllGroupList()
    this.getAllTypeList()
  }

  lastSevenDays: string[] = [];
  last_7_days: any
  
  getAllBranch(){
    this.generic_service.getBranch().subscribe(
      (response:any)=>{
        this.branchList = response.response;
      }
    )
  }

    getAllLocation(){
    this.generic_service.getAllLocation().subscribe(
      (res:any)=> {
        console.log(res)
        this.locationList = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }
  
  toggleGrid(){
    this.isDisplayGrid = !this.isDisplayGrid
  }

  generateLastSevenDays() {
    const today = new Date();
    for (let i = 0; i < 7; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() - i);
      this.lastSevenDays.push(formatDate(date, 'dd-MM-yy', 'en-US'));

    }
    let dates: any = this.lastSevenDays.join(',');
    this.last_7_days = dates
  }
  


  initChart() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--p-text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--p-text-muted-color');
    const surfaceBorder = documentStyle.getPropertyValue('--p-content-border-color');
    const bgColorPrimary = documentStyle.getPropertyValue('--bg-color-primary');
    const bgColorSecondary = documentStyle.getPropertyValue('--bg-color-secondary');
    const bgColorTertiary = documentStyle.getPropertyValue('--bg-color-tertiary');
    const bgColorAccent = documentStyle.getPropertyValue('--bg-color-accent');

    // this.data = {
    //   labels: this.lastSevenDays,
    //   datasets: [
    //     {
    //       label: 'Heat',
    //       backgroundColor: documentStyle.getPropertyValue('--p-cyan-500'),
    //       borderColor: documentStyle.getPropertyValue('--p-cyan-500'),
    //       data: this.dataSet1,
    //     },
    //     {
    //       label: 'Pressure',
    //       backgroundColor: documentStyle.getPropertyValue('--p-gray-500'),
    //       borderColor: documentStyle.getPropertyValue('--p-gray-500'),
    //       data: this.dataSet2,
    //     },
    //     {
    //       label: 'Min-Value',
    //       backgroundColor: documentStyle.getPropertyValue('--p-cyan-500'),
    //       borderColor: documentStyle.getPropertyValue('--p-cyan-500'),
    //       data: this.dataSet3,
    //     },
    //     {
    //       label: 'Max-Value',
    //       backgroundColor: documentStyle.getPropertyValue('--p-gray-500'),
    //       borderColor: documentStyle.getPropertyValue('--p-gray-500'),
    //       data: this.dataSet4,
    //     }
    //   ]
    // };

    this.data1 = {
      labels: this.lastSevenDays,
      datasets: [
        {
          label: 'Heat',
          backgroundColor: documentStyle.getPropertyValue('--bg-color-blue'),
          borderColor: documentStyle.getPropertyValue('--bg-color-blue'),
          data: this.dataSet1
        }
      ]
    };

    this.data2 = {
      labels: this.lastSevenDays,
      datasets: [
        {
          label: 'Pressure',
          backgroundColor: documentStyle.getPropertyValue('--bg-color-yellow'),
          borderColor: documentStyle.getPropertyValue('--bg-color-yellow'),
          data: this.dataSet2
        }
      ]
    };

    this.data3 = {
      labels: this.lastSevenDays,
      datasets: [
        {
          label: 'Min-Value',
          backgroundColor: documentStyle.getPropertyValue('--bg-color-orange'),
          borderColor: documentStyle.getPropertyValue('--bg-color-orange'),
          data: this.dataSet3
        }
      ]
    };

    this.data4 = {
      labels: this.lastSevenDays,
      datasets: [
        {
          label: 'Max-Value',
          backgroundColor: documentStyle.getPropertyValue('--bg-color-pink'),
          borderColor: documentStyle.getPropertyValue('--bg-color-pink'),
          data: this.dataSet4
        }
      ]
    };

    this.options = {
        maintainAspectRatio: false,
        aspectRatio: 0.8,
        plugins: {
            legend: {
                labels: {
                    color: textColor
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: textColorSecondary,
                    font: {
                        weight: 500
                    }
                },
                grid: {
                    color: surfaceBorder,
                    drawBorder: false
                }
            },
            y: {
                ticks: {
                    color: textColorSecondary
                },
                grid: {
                    color: surfaceBorder,
                    drawBorder: false
                }
            }
        }
    };


    this.lineOptions = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
          legend: {
              labels: {
                  color: textColor
              }
          }
      },
      scales: {
          x: {
              ticks: {
                  color: textColorSecondary
              },
              grid: {
                  color: surfaceBorder,
                  drawBorder: false
              }
          },
          y: {
              ticks: {
                  color: textColorSecondary
              },
              grid: {
                  color: surfaceBorder,
                  drawBorder: false
              }
          }
      }
    };
  }


  onTableDataChange(event: any) {
    console.log(event)
    this.page = event.page+1;
  }

  getObjectInfoById(objectInfoId: any){
    this.getFourRandomArrays()

    this.objectInfoId = objectInfoId
    this.generic_service.getObjectInfoById(objectInfoId).subscribe(
      (response:any)=>{
        console.log(response);
        // this.singleObjectInfoData = []
        // this.singleObjectInfoData.push(response.response)

        // this.getPerformanceMatrixHistoryByObjectInfoId(objectInfoId)

        const date = formatDate( new Date(), 'yyyy-MM-dd', 'en-US')
        this.getPerformanceMatrixHistoryByObjectIdAndDate(date,objectInfoId)

      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  getPerformanceMatrixHistoryByObjectIdAndDate(date: any,objectInfoId: any){
    this.generic_service.getPerformanceMatrixHistoryByObjectIdAndDate(date,objectInfoId).subscribe(
      (response:any)=>{
        console.log(response);
        let groupedData = this.groupByDateTime(response.response.performanceMatrixHistoryWithTimes);
        console.log(groupedData)

        this.prepareChartData(response.response.performanceMatrixHistoryWithTimes)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  getPerformanceMatrixHistoryByObjectInfoId(objectInfoId: any){
    this.generic_service.getPerformanceMatrixHistoryByObjectInfoId(objectInfoId).subscribe(
      (response:any)=>{
        console.log(response);
        let groupedData = this.groupByDateTime(response.response.performanceMatrixHistoryWithTimes);
        console.log(groupedData)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  getPerformanceMatrixHistoryByDate(dateAndTime: any){
    this.generic_service.getPerformanceMatrixHistoryByDate(dateAndTime).subscribe(
      (response:any)=>{
        console.log(response);
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }


  getAllByAssetMonitoringAndCid(assetMonitoring: any) {
    this.generic_service.getAllByAssetMonitoringAndCid(assetMonitoring).subscribe(
      (response: any) => {
        console.log(response.response)
        let objectInfo: any = []
        for (let list of response.response) {
          if (list.assetMonitoring) {
            objectInfo.push(list)
          }

        }
        this.objectInfoList = objectInfo || []

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getAllObjectInfo(){
    this.generic_service.getAllObjectInfo().subscribe(
      (response:any)=>{
        console.log(response);
        this.objectInfoList = response.response
        this.objectInfoListFilter = response.response
        this.count = response.response.length
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  performanceMatrixHistory(){
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "performanceMatrixHistoryWithTimes": [
      {
      "version": 0,
      "isActive": true,
      "description": "",
      "key": "pressure",
      "value": "200",
      "dateAndTime": 1710483600000
    }
      ],
      "objectId": 78,
      "cid": Number(this.cid)
    }
    console.log(body)
    this.generic_service.performanceMatrixHistory(body).subscribe(
      (response:any)=> {
        console.log(response)
        this.toastr.success(response.message);
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
      }
    )
  }







  getAllModelByAndCid(model: any) {
    this.generic_service.getAllModelByAndCid(model).subscribe(
      (res: any) => {
        console.log('Model Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          return
        }
        this.objectInfoList = res.response
      },
      (err: any) => {
        console.log('Model Error:', err);
      }
    );
  }

  getAllMakeByAndCid(make: any) {
    this.generic_service.getAllMakeByAndCid(make).subscribe(
      (res: any) => {
        console.log('Make Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
      },
      (err: any) => {
        console.log('Make Error:', err);
      }
    );
  }

  getAllByType(type: any) {
    this.generic_service.getAllByType(type).subscribe(
      (res: any) => {
        console.log('Type Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
      },
      (err: any) => {
        console.log('Type Error:', err);
      }
    );
  }

  getAllBySerialNumberAndCid(serialNumber: any) {
    this.generic_service.getAllBySerialNumberAndCid(serialNumber).subscribe(
      (res: any) => {
        console.log('Serial Number Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }

  getAllByObjectConditionAndCid(objectCondition: any) {
    this.generic_service.getAllByObjectConditionAndCid(objectCondition).subscribe(
      (res: any) => {
        console.log('Object Condition Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
      },
      (err: any) => {
        console.log('Object Condition Error:', err);
      }
    );
  }

  getAllByBranchAndCid(branch: any) {
    this.generic_service.getAllByBranchAndCid(branch).subscribe(
      (res: any) => {
        console.log('Branch Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
      },
      (err: any) => {
        console.log('Branch Error:', err);
      }
    );
  }

  getAllByDepartmentAndCid(department: any) {
    this.generic_service.getAllByDepartmentAndCid(department).subscribe(
      (res: any) => {
        console.log('Department Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
      },
      (err: any) => {
        console.log('Department Error:', err);
      }
    );
  }

  getAllByGroup(group: any) {
    this.generic_service.getAllByGroup(group).subscribe(
      (res: any) => {
        console.log('Group Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
      },
      (err: any) => {
        console.log('Group Error:', err);
      }
    );
  }

  getAllObjectInfoByGroupAndType(group: any, type: any) {
    this.generic_service.getAllObjectInfoByGroupAndType(group, type).subscribe(
      (res: any) => {
        console.log('Group and Type Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
     
          return

        }
        this.objectInfoList = res.response
      },
      (err: any) => {
        console.log('Group and Type Error:', err);
      }
    );
  }

  toggleFilter(){
    this.showFilter = !this.showFilter
  }

  refreshTickets(){
    this.singleObjectInfoData = []
    this.showFilter = false
    this.getAllObjectInfo()
  }

  getAllTypeList(){
    this.generic_service.getAllTypeList().subscribe(
      (res:any)=> {
        console.log(res)
        this.objectTypeData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getAllGroupList(){
    this.generic_service.getAllGroupList().subscribe(
      (res:any)=> {
        console.log(res)
        this.objectGroupData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }


modelChecked = false;
modelFilter = "";

makeChecked = false;
makeFilter = "";

typeChecked = false;
typeFilter = "";

serialNumberChecked = false;
serialNumberFilter = "";

objectConditionChecked = false;
objectConditionFilter = "";

branchChecked = false;
branchFilter = "";

locationChecked = false;
locationFilter = "";

departmentChecked = false;
departmentFilter = "";

groupChecked = false;
groupFilter = "";

onFilterSelect(selected: string) {
  console.log(selected)
 

  this.modelChecked = false
  this.makeChecked = false
  this.typeChecked = false
  this.serialNumberChecked = false
  this.objectConditionChecked = false
  this.branchChecked = false
  this.departmentChecked = false
  this.groupChecked = false
  this.locationChecked = false

  if(selected == "modelFilter"){
    this.modelChecked = true
  }

  if(selected == "makeFilter"){
    this.makeChecked = true
  }

    if(selected == "typeFilter"){
    this.typeChecked = true
  }

    if(selected == "serialNumberFilter"){
    this.serialNumberChecked = true
  }

  if(selected == "objectConditionFilter"){
    this.objectConditionChecked = true
  }

  if(selected == "branchFilter"){
    this.branchChecked = true
  }

  if(selected == "departmentFilter"){
    this.departmentChecked = true
  }

  if(selected == "groupFilter"){
    this.groupChecked = true
  }

  if(selected == "locationFilter"){
    this.locationChecked = true
  }
}

resetFilter(){


  // this.modelChecked = false
  // this.makeChecked = false
  // this.typeChecked = false
  // this.serialNumberChecked = false
  // this.objectConditionChecked = false
  // this.branchChecked = false
  // this.departmentChecked = false
  // this.groupChecked = false

  this.getAllObjectInfo()
}

applyFilter() {
  if (this.modelChecked) {
    this.getAllModelByAndCid(this.model);
  }

  if (this.makeChecked) {
    this.getAllMakeByAndCid(this.make);
  }

  if (this.typeChecked) {
    this.getAllByType(this.typeFilter);
  }

  if (this.serialNumberChecked) {
    this.getAllBySerialNumberAndCid(this.serialNumberFilter);
  }

  if (this.objectConditionChecked) {
    this.getAllByObjectConditionAndCid(this.objectConditionFilter);
  }

  if (this.branchChecked) {
    this.getAllByBranchAndCid(this.branchFilter);
  }

  if (this.departmentChecked) {
    this.getAllByDepartmentAndCid(this.departmentFilter);
  }

  if (this.groupChecked) {
    this.getAllByGroup(this.groupFilter);
  }

  if (this.locationChecked) {
    this.getAllByLocationAndCid(this.locationFilter);
  }


}

  getAllByLocationAndCid(location: any){
    this.generic_service.getAllByLocationAndCid(location).subscribe(
      (res: any) => {
        console.log('Location Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }


  getFourRandomArrays() {
    this.isLoading1 = true

    this.dataSet1 = []
    this.dataSet2 = []
    this.dataSet3 = []
    this.dataSet4 = []

    const result: any= [];

    for (let i = 0; i < 4; i++) {
      const array: number[] = [];

      for (let j = 0; j < 7; j++) {
        const randomNum = Math.floor(Math.random() * 99) + 1; // 1 to 99
        array.push(randomNum);
      }

      result.push(array);
    }

    this.dataSet1 = result[0]
    this.dataSet2 = result[1]
    this.dataSet3 = result[2]
    this.dataSet4 = result[3]
    this.initChart();

    console.log(result)
    this.isLoading1 = false

    // return result;
  }



  groupByDateTime(data: any): { [key: number]: any[] } {
    return data.reduce((acc: any, item: any) => {
      const dateTime = item.dateTime;
      if (!acc[dateTime]) {
        acc[dateTime] = [];
      }
      acc[dateTime].push(item);
      return acc;
    }, {} as { [key: number]: any[] });
  }

  formatDate(ms: number): string {
    return new Date(ms).toLocaleString();
  }

   prepareChartData(originalData: any) {
    // Step 1: Get sorted unique timestamps
    const uniqueTimes = Array.from(
      new Set(originalData.map((d: any) => d.dateTime))
    ).sort((a: any, b: any) => a - b);

    const labels = uniqueTimes.map((ms: any) => new Date(ms).toLocaleString());

    // Step 2: Get unique keys
    const uniqueKeys = Array.from(
      new Set(originalData.map((d: any) => d.key.toLowerCase()))
    );

    // Step 3: Build datasets for each key
    const datasets = uniqueKeys.map(key => {
      const data = uniqueTimes.map(time => {
        const item = originalData.find(
          (d: any) => d.dateTime === time && d.key.toLowerCase() === key
        );
        return item ? Number(item.value) : 0; // or 0 if you prefer
      });

      return {
        label: key,
        data
      };
    });

    this.data = {
      labels,
      datasets
    };

    console.log(this.data)
  }


  ngOnDestroy(){
    console.log("ok")
  }


}